import { render, staticRenderFns } from "./KickUnReadAll.vue?vue&type=template&id=747d70d7&scoped=true&"
import script from "./KickUnReadAll.vue?vue&type=script&lang=js&"
export * from "./KickUnReadAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d70d7",
  null
  
)

export default component.exports